import axios from 'axios';
import { useMutation } from 'react-query';

export type MigrateFromContentApiResponse = {
  code: string;
  message: string;
};

const migrateFromContentApi = async (
  merchantId: string,
): Promise<MigrateFromContentApiResponse> => {
  const { data } = await axios.post(
    `/api/merchants/${merchantId}/migrate-from-content-api`,
  );
  return data;
};

export const useMigrateFromContentApi = ({ onSuccess, onError }) => {
  return useMutation(migrateFromContentApi, {
    onSuccess,
    onError,
  });
};
